import { Injectable } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { catchError, Observable, retry, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GeolocationService {

    get geolocation() {
        return this.windowRef.nativeWindow.navigator.geolocation;
    }

    constructor(
        private windowRef: WindowRef,
    ) { }

    getLocation() {
        return new Observable<GeolocationCoordinates>((observer) => {
            if (!this.geolocation) {
                const msg = `Geolocation access denied`;
                console.log(`***** ${msg}`);
                observer.error(msg);

                return;
            }

            this.geolocation.getCurrentPosition(
                // success callback when the position is successfully obtained
                (position: GeolocationPosition) => {
                    observer.next(position.coords);
                    observer.complete();
                },
                // error callback when the position is not successfully obtained
                // or the guest denies access to their location
                (error: GeolocationPositionError) => {
                    const msg = `Geolocation access denied`;
                    console.log(`***** ${msg}`);
                    observer.next(void 0);
                    observer.error(error);
                }
            );
        })
        .pipe(
            retry(1),
            catchError(error => {
                console.error(`***** Geolocation Service Error`, error);

                return throwError(() => new Error(error));
            })
        );

    }
}
